import './SurveyError.css';
import cx from 'classnames';

const SurveyError = ({ errorMessage }) => {

  if(!errorMessage)
    return null;

  return (
    <div className={cx("error-message", { show: errorMessage })}>
      {errorMessage}
    </div>
  );
};
export default SurveyError;
